import { type ReactNode, useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { GlowOrb } from '@/components/effects/glow-orb';
import {
  checkIdentity,
  getCachedIdentity,
  type IdentityState,
} from '@/core/identity-check';
import { useRegistrationOpen } from '@/hooks/use-registration-open';
import { RegistrationClosedScreen } from './registration-closed';

function useIdentityCheck(pathname: string): IdentityState {
  const [state, setState] = useState<IdentityState>(
    () => getCachedIdentity() ?? { status: 'checking' }
  );
  useEffect(() => {
    let cancelled = false;
    void checkIdentity().then((next) => {
      if (!cancelled) setState(next);
    });
    return () => {
      cancelled = true;
    };
  }, [pathname]);
  return state;
}

function GuardLoader(): ReactNode {
  return (
    <div className="relative flex min-h-dvh items-center justify-center bg-void">
      <GlowOrb />
    </div>
  );
}

export function RegistrationGuard(): ReactNode {
  const location = useLocation();
  const state = useIdentityCheck(location.pathname);
  const reg = useRegistrationOpen();
  if (state.status === 'checking' || reg.isLoading) return <GuardLoader />;
  if (!reg.open) return <RegistrationClosedScreen />;
  if (state.status === 'blocked' && location.pathname !== '/register') {
    return <Navigate to="/register" replace />;
  }
  return <Outlet />;
}
